(() => {
  const initializeFaq = (panel) => {
    if (panel.dataset.xnMembershipReady === 'true') return;

    const buttons = Array.from(panel.querySelectorAll('[data-xn-membership-faq-button]'));
    buttons.forEach((button) => {
      const answerId = button.getAttribute('aria-controls');
      const answer = answerId ? document.getElementById(answerId) : null;
      if (!answer) return;

      button.setAttribute('aria-expanded', 'false');
      answer.hidden = true;

      button.addEventListener('click', () => {
        const shouldOpen = button.getAttribute('aria-expanded') !== 'true';

        buttons.forEach((otherButton) => {
          const otherAnswerId = otherButton.getAttribute('aria-controls');
          const otherAnswer = otherAnswerId ? document.getElementById(otherAnswerId) : null;
          otherButton.setAttribute('aria-expanded', 'false');
          if (otherAnswer) otherAnswer.hidden = true;
        });

        button.setAttribute('aria-expanded', String(shouldOpen));
        answer.hidden = !shouldOpen;

        if (shouldOpen) {
          document.dispatchEvent(new CustomEvent('xenith_nini_faq_open', {
            detail: { question: button.textContent.trim() },
          }));
        }
      });
    });

    panel.dataset.xnMembershipReady = 'true';
  };

  const initialize = (root = document) => {
    root.querySelectorAll('[data-xn-membership-faq]').forEach(initializeFaq);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize());
  } else {
    initialize();
  }

  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
